import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { GlobalFormGroup } from '@app/services/formulario';
import { convertErrorsNz } from '@app/utiles/ng-zorro';
import { format, isValid, parse, parseISO } from 'date-fns';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';

@Component({ standalone: false, selector: 'app-form-reactive-datepicker',
  templateUrl: './reactive-datepicker.component.html',
})
export class FormReactiveDatePicker<T> implements OnInit {
  @Input() label: string = '';
  @Input() controlName: string = '';
  @Input() readonly : boolean = false;
  @Input() formatDate: string = 'yyyy-MM-dd'; // 'dd/MM/yyyy'
  @Input() tooltipTitle: string = null;
  date: Date = null;
  _inputFormControl: GlobalFormGroup<string> = null;
  @Input() set inputFormControl(inputFormControl: GlobalFormGroup<string>) {
    if (!inputFormControl) return;
    this._inputFormControl = inputFormControl;
    const value = inputFormControl.value;
    if (!value) {
      this.date = null;
      return;
    }

    const rawValue: any = value;
    const parsedDate = rawValue instanceof Date
      ? rawValue
      : parse(value, 'yyyy-MM-dd HH:mm:ss', new Date());
    const isoDate = !isValid(parsedDate) && typeof value === 'string' ? parseISO(value) : parsedDate;
    this.date = isValid(isoDate) ? isoDate : null;
  }
  get inputFormControl() {
    return this._inputFormControl;
  }
  @Output() readonly openDataPicker = new EventEmitter<NzDatePickerComponent>();
  readonly convertErrorsNz = convertErrorsNz;
  // Necesario para evitar el error de tipado para [formControl] (https://github.com/ngx-formly/ngx-formly/issues/2842)
  readonly asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;

  ngOnInit(): void {
    this.inputFormControl.markAsDirty();
  }
  onOpenDatePicker(nzDatePicker: NzDatePickerComponent) {
    if(this.inputFormControl.disabled) return;
    this.openDataPicker.emit(nzDatePicker);
  }
  onChangeDate(date: Date) {
    // Se guarda en formato ISO compatible con el backend.

    if (!this.inputFormControl) return;

    if (date === null) {
      this.inputFormControl.setValue(null);
    } else {
      // Usa 24h para evitar ambigüedad y falsos “sin cambio”
      const val = format(date, 'yyyy-MM-dd HH:mm:ss');
      this.inputFormControl.setValue(val);
    }

    // 👇 muy importante para que el formulario “detecte cambios”
    this.inputFormControl.markAsDirty();
    this.inputFormControl.markAsTouched();

    // Mantén el estado interno alineado con el picker
    this.date = date;
  }
}
